import React, { useEffect } from 'react'
import Card from '../../../components/common/Card/Card'

import styles from "./InfoPage.module.css"

const InfoPage = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);


    return (
        <div className={styles.infoPage}>
            <h1 className={styles.pageTitle}>Obecné informace</h1>
            <Card id="info" className={`${styles.infoContent}`} >
                <iframe width={560 * 1.77} height={315 * 1.77} src="https://www.youtube.com/embed/eFb-52ZuGTA?si=qOv1kA5UI3x0U7fr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </Card>
        </div>
    )
}

export default InfoPage